import React from 'react';
import Input from './Input';
import LinkedVulnerabilities from './LinkedVulnerabilities';

const BULK_UPDATE_COMPONENTS = {
  endpoint: <Input />,
  username: <Input />,
  password: <Input />,
  vulnerabilities: <LinkedVulnerabilities />
};

export default BULK_UPDATE_COMPONENTS;
